import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { UserService } from "../user.service";
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export abstract class BASEMysqlService {

    abstract prefix;
  
    URL_BASE = '';
  
    constructor(protected http: HttpClient, protected router: Router, protected userService: UserService) {
  
      this.URL_BASE = window.location.href.split('/').slice(0, 3).join('/');
      let host = window.location.href.split('/')[2].split(':')[0];
  
      if (host == 'localhost') {
        this.URL_BASE = 'https://app.g-academy.cloud/';
        this.URL_BASE += 'api/api.php?cmd=';
      } else {
        this.URL_BASE = window.location.href.split('/').slice(0, 3).join('/');
        this.URL_BASE += '/api/api.php?cmd=';
      }
  
    }
  
    getAuth() {
      return this.userService.getCurrentUser()
    }
  
  
  }